"use client";

import Image from "next/image";
import Formulario from "./Formulario";
import { IconPhone, IconMail } from "@/lib/tabler-icons";
import { CONFIG } from "@/constants/config";
import { SectionHeading } from "@/components/ui/editorial";

const ContactSection = () => {
	return (
		<section
			id="contacto"
			aria-label="Co-creemos tu proyecto"
			className="px-4 xl:px-0 py-16"
		>
			<div className="container max-w-7xl mx-auto space-y-12">
				{/* Header editorial */}
				<header>
					<SectionHeading
						index="06"
						title="Co-creemos tu proyecto"
						kicker="Contacto Directo"
					/>
					<p className="font-body text-lg mt-4 max-w-3xl leading-relaxed text-muted-foreground">
						Cuéntanos la realidad que quieres transformar. Te respondemos en
						48h.
					</p>
				</header>

				{/* Información de contacto */}
				<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
					<div className="flex items-center gap-4 p-5 border border-border rounded-xl">
						<div className="p-3 border border-border rounded-lg shrink-0">
							<IconMail className="w-5 h-5 text-terracotta" />
						</div>
						<div>
							<h3 className="font-display font-semibold text-ink mb-0.5">Email</h3>
							<p className="font-body text-muted-foreground text-sm">
								{CONFIG.CONTACT_EMAIL}
							</p>
						</div>
					</div>

					<div className="flex items-center gap-4 p-5 border border-border rounded-xl">
						<div className="p-3 border border-border rounded-lg shrink-0">
							<IconPhone className="w-5 h-5 text-terracotta" />
						</div>
						<div>
							<h3 className="font-display font-semibold text-ink mb-0.5">Teléfono</h3>
							<p className="font-body text-muted-foreground text-sm">
								{CONFIG.CONTACT_PHONE}
							</p>
						</div>
					</div>
				</div>

				{/* Contenedor principal */}
				<div className="border border-border rounded-xl overflow-hidden">
					<div className="lg:grid lg:grid-cols-2 lg:gap-0">
						{/* Imagen decorativa */}
						<div className="hidden lg:block relative">
							<figure className="h-full">
								<Image
									src="/assets/imagen-puñosVertical.jpg"
									alt="Puños unidos, símbolo de colaboración y trabajo en equipo"
									className="object-cover w-full h-full"
									width={400}
									height={600}
									loading="lazy"
									sizes="(max-width: 1024px) 100vw, 50vw"
								/>
								{/* Overlay con texto */}
								<div className="absolute inset-0 bg-ink/60 flex items-end">
									<div className="p-8 text-cream">
										<h3 className="font-display text-2xl font-semibold mb-2">
											Trabajemos juntos
										</h3>
										<p className="font-body text-base text-cream/85 leading-relaxed">
											Cada proyecto comienza con una conversación. Estamos aquí
											para escucharte y co-crear soluciones.
										</p>
									</div>
								</div>
							</figure>
						</div>

						{/* Formulario */}
						<div className="p-8 lg:p-12">
							<Formulario />
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default ContactSection;
